import Vue from 'vue';
import { UPLOAD_DOCUMENTS, FETCH_DOCUMENTS, DELETE_DOCUMENTS } from './mutation-types';

export function uploadDocuments({ commit }, form) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/documents/upload`, form,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then(res => {
            commit(UPLOAD_DOCUMENTS);
            resolve(res);
        }).catch(error => {
            reject(error);
        });
    });
};

export function fetchDocuments({ commit }, employeeId) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/documents/${employeeId}`
        ).then(res => {
            commit(FETCH_DOCUMENTS, res.data);
            resolve(res);
        }).catch(error => {
            reject(error);
        });
    });
};

export function deleteDocuments({ commit }, documentsId) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/documents/delete`, documentsId
        ).then(res => {
            commit(DELETE_DOCUMENTS, documentsId);
            resolve(res);
        }).catch(error => {
            reject(error);
        });
    });
};

export function downloadDocument({ commit }, fileName) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/documents/download?filename=${fileName}`,
            {
                headers: {
                    'Content-disposition': `attachment; filename=${fileName}`,
                    'Content-Type': 'application/octet-stream'
                },
                responseType: 'blob'
            }
        ).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            resolve(res);
        }).catch(error => {
            reject(error);
        });
    });
};



// WEBPACK FOOTER //
// ./src/store/modules/document/actions.js